import { Modal } from '@/components/ui/Modal';
import { useUseItem, useWaifusForItem } from '@/api/queries';
import { useAuthStore } from '@/store/authStore';
import { useModalPayload, useUIStore } from '@/store/uiStore';
import { hapticNotify } from '@/lib/telegram';
import { imageUrl } from '@/api/client';
import type { InventoryItem, UsableItemId } from '@/types';

interface Payload {
  itemId: UsableItemId;
  item: InventoryItem;
}

export function ItemTargetWaifuModal() {
  const open = useUIStore((s) => s.isModalOpen('item-target-waifu'));
  const closeModal = useUIStore((s) => s.closeModal);
  const payload = useModalPayload<Payload>('item-target-waifu');
  const userId = useAuthStore((s) => s.userId) ?? 0;
  const pushNotification = useUIStore((s) => s.pushNotification);
  const useItem = useUseItem(userId);

  const itemId = payload?.itemId ?? null;
  const { data, isLoading } = useWaifusForItem(open ? userId : null, itemId);
  const waifus = data?.waifus ?? [];

  if (!open || !payload) return null;

  return (
    <Modal
      open={open}
      onClose={() => closeModal('item-target-waifu')}
      title={`Использовать: ${payload.item.name}`}
      size="lg"
    >
      <div className="p-4 space-y-2">
        {isLoading && <div className="text-white/40 text-sm">Загружаем…</div>}
        {!isLoading && waifus.length === 0 && (
          <div className="text-white/40 text-sm">Нет подходящих waifu.</div>
        )}
        {waifus.map((w) => (
          <button
            key={w.id}
            onClick={async () => {
              try {
                const res = await useItem.mutateAsync({
                  item_id: payload.itemId,
                  waifu_id: w.id,
                });
                if (res.success) {
                  hapticNotify('success');
                  pushNotification({
                    type: 'success',
                    message: res.message ?? `${payload.item.name} → ${w.name}`,
                  });
                } else {
                  pushNotification({ type: 'error', message: res.error ?? 'Ошибка' });
                }
                closeModal('item-target-waifu');
              } catch (err) {
                hapticNotify('error');
                const message =
                  err instanceof Error ? err.message : 'Не удалось применить';
                pushNotification({ type: 'error', message });
              }
            }}
            className="w-full flex items-center gap-3 p-3 rounded-xl bg-bg-elevated border border-white/5 hover:border-white/20 transition active:scale-[0.98]"
          >
            <div className="w-12 h-12 rounded-xl overflow-hidden bg-bg-muted shrink-0">
              {w.portrait_url && (
                <img
                  src={imageUrl(w.portrait_url) ?? ''}
                  alt={w.name}
                  className="w-full h-full object-cover"
                />
              )}
            </div>
            <div className="flex-1 text-left">
              <div className="text-sm text-white font-medium">{w.name}</div>
              <div className="text-[10px] text-white/50">
                HP {w.current_hp}/{w.max_hp} · Lv. {w.level}
              </div>
            </div>
          </button>
        ))}
      </div>
    </Modal>
  );
}
